"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("./Box"));

var _Drawer = _interopRequireDefault(require("./Drawer"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

var _List = _interopRequireDefault(require("./List"));

var _ListItemIcon = _interopRequireDefault(require("./ListItemIcon"));

var _Typography = _interopRequireDefault(require("./Typography"));

var _Grid = _interopRequireDefault(require("./Grid"));

var _icons = require("../icons");

var _profile = _interopRequireDefault(require("../assets/profile.svg"));

var _watermark = _interopRequireDefault(require("../assets/watermark.svg"));

var _logoWide = _interopRequireDefault(require("../assets/logo-wide.svg"));

var _logoMini = _interopRequireDefault(require("../assets/logo-mini.svg"));

var _Navbar = _interopRequireDefault(require("./Navbar.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Navbar = function Navbar(_ref) {
  var children = _ref.children,
      name = _ref.name,
      subText = _ref.subText,
      profileImage = _ref.profileImage,
      onSettingsClick = _ref.onSettingsClick,
      onOpenStatusChanged = _ref.onOpenStatusChanged;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var classes = (0, _Navbar.default)({
    isOpen: isOpen
  });
  return /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    variant: "permanent",
    classes: {
      paper: (0, _clsx.default)(classes.drawerPaper, !isOpen && classes.drawerPaperClose)
    },
    open: isOpen,
    style: {
      minWidth: isOpen ? '14.813rem' : ''
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 1,
    className: (0, _clsx.default)(classes.grid, !isOpen && classes.gridCollapsed)
  }, isOpen && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.toolbarIcon
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    style: {
      padding: 0
    },
    color: "secondary",
    onClick: function onClick() {
      setIsOpen(!isOpen);
      if (onOpenStatusChanged) onOpenStatusChanged({
        open: !isOpen
      });
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.ChevronLeft, null))), /*#__PURE__*/_react.default.createElement("img", {
    src: _logoWide.default,
    className: classes.logoWide,
    alt: "LogoWide"
  })), !isOpen && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "secondary",
    onClick: function onClick() {
      setIsOpen(!isOpen);
      if (onOpenStatusChanged) onOpenStatusChanged({
        open: !isOpen
      });
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Menu, null))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _logoMini.default,
    className: classes.logo,
    alt: "LogoMini"
  })))), isOpen && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    direction: "column",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.profileContainer
  }, profileImage ? profileImage : /*#__PURE__*/_react.default.createElement("img", {
    src: _profile.default,
    className: classes.profile,
    alt: "DefaultProfileImage"
  }), /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_icons.SettingsOutlined, {
    onClick: onSettingsClick,
    className: classes.profileSetting
  }))), name ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    className: classes.profileName
  }, name) : undefined, subText ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "overline",
    className: classes.profileName
  }, subText) : undefined), /*#__PURE__*/_react.default.createElement(_List.default, {
    component: "nav"
  }, !isOpen && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    justifyContent: "center",
    className: classes.gridCollapsed
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: onSettingsClick
  }, /*#__PURE__*/_react.default.createElement(_icons.SettingsOutlined, {
    color: "secondary"
  }))), children), /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.combinedShapeImg,
    mt: 9
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _watermark.default,
    alt: "Watermark"
  })));
};

Navbar.propTypes = {
  onOpenStatusChanged: _propTypes.default.func
};
Navbar.defaultProps = {
  onOpenStatusChanged: undefined
};
var _default = Navbar;
exports.default = _default;